const getoffiledata = async (fileName) => {
    return await window.api.readItemData(fileName);
}

export default getoffiledata;